// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//vuex
import store from './store'
import router from './router'
import Router  from 'vue-router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import VueI18n from 'vue-i18n'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css'
Vue.use(VueAwesomeSwiper)

import Swiper2, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
Swiper2.use([Navigation, Pagination, EffectFade, Autoplay])

//公共js方法
import commom from '@/assets/js/common.js'

import '@/assets/css/init.css'
import '@/assets/css/cssPublic.css'

Vue.use(Router)

Vue.use(VueI18n) // 通过插件的形式挂载

Vue.use(ElementUI)

Vue.config.productionTip = false
/* eslint-disable no-new */

const i18n = new VueI18n({
    locale: 'zh-CN',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
      'zh-CN': require('./common/lang/zh'),   // 中文语言包
      'en-US': require('./common/lang/en')    // 英文语言包
    }
})

window.v = new Vue({
  el: '#app',
  i18n,  // 不要忘记这里也要配置
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js